import React from "react";
import { getField } from "../../../../util/DynamicItemUtils";

export default function Amendments({ item }: any) {
  const partTwoAmendmentLabels = [
    { document: "amendmentauditreport", text: "Item 3.1, Audit Report" },
    {
      document: "amendmentotherfirms",
      text: "Item 3.2, Other Accounting Firms",
    },
    {
      document: "amendmentdividedresponsibility",
      text: "Item 3.3, Divided Responsibility",
    },
  ];

  const partThreeAmendmentLabels = [
    {
      document: "amendmentparticipantsmorethan5",
      text:
        "Item 4.1, Other Accounting Firm(s) Individually 5% or Greater of Total Audit Hours ",
    },
    {
      document: "amendmentparticipantslessthan5",
      text:
        "Item 4.2, Other Accounting Firm(s) Individually Less Than 5% of Total Audit Hours ",
    },
  ];

  const partTwoAmendments = partTwoAmendmentLabels.filter(
    (amendment) => getField(item, amendment.document) === "True"
  );

  const partThreeAmendments = partThreeAmendmentLabels.filter(
    (amendment) => getField(item, amendment.document) === "True"
  );

  return (
    <div className="form-card">
      <h2>Amendments</h2>
      <p>Parts of FORM AP that are changed from most recent FORM AP filed</p>
      <ul>
        {getField(item, "amendmentfirmidentification") === "True" && (
          <li>
            <input type="checkbox" disabled checked />
            Part &#8544;, Identity of the firm
          </li>
        )}
        {partTwoAmendments.length > 0 && (
          <li>
            Part &#8546;, Audit Client &amp; Audit Report
            <ul>
              {partTwoAmendments.map((amendment, i) => (
                <li key={`part-two-amendment_${i}`}>
                  <input type="checkbox" disabled checked />
                  {amendment.text}
                </li>
              ))}
            </ul>
          </li>
        )}
        {partThreeAmendments.length > 0 && (
          <li>
            Part &#8547;, Responsibility for the Audit is not Divided
            <ul>
              {partThreeAmendments.map((amendment, i) => (
                <li key={`part-three-amendment_${i}`}>
                  <input type="checkbox" disabled checked />
                  {amendment.text}
                </li>
              ))}
            </ul>
          </li>
        )}
        {getField(item, "amendmentauditdivided") === "True" && (
          <li>
            <input type="checkbox" disabled checked />
            Part &#8548;, Responsibility for the Audit is Divided
          </li>
        )}
        {getField(item, "amendmentcertifiedfirm") === "True" && (
          <li>
            <input type="checkbox" disabled checked />
            Part &#8549;, Certification of the Firm
          </li>
        )}
      </ul>
      {getField(item, "amendmentcertifiedfirm") === "True" && (
        <div className="amended-firm">
          <p className="amended-firm__details">
            Information that describes the error or omission in Part &#8549; as
            previously filed
          </p>
          <p>{getField(item, "amendmentcertifiedfirminfo")}</p>
        </div>
      )}
    </div>
  );
}
